import resolveConfig from "tailwindcss/resolveConfig";

import twConfig from "@hsl/lgim/tailwind.config";

const config = resolveConfig(twConfig);

const theme = config.theme as unknown as typeof config.theme.extend;
const colors = theme.colors;

export default colors;
